"use client";

import { type ReactNode, useCallback, useRef } from "react";

import { useTranslations } from "next-intl";
import { heroFeatureChips } from "./hero-chip-defs";
import { HeroDemoCursor } from "./hero-demo-cursor";
import { Pill } from "./hero-primitives";
import { H, MOBILE_HERO_GUTTER } from "./hero-tokens";
import type { HeroModuleKey } from "./hero-types";

export function HeroMobileChips(props: {
  readonly active: HeroModuleKey;
  readonly setActive: (key: HeroModuleKey) => void;
}): ReactNode {
  const t = useTranslations("marketing.heroMobileChips");
  const tChips = useTranslations("marketing.heroChipDefs");
  const chipRowRef = useRef<HTMLDivElement | null>(null);

  const handleChipClick = useCallback(
    (key: HeroModuleKey): void => {
      props.setActive(key);
    },
    [props.setActive],
  );

  return (
    <>
      <div
        style={{
          textAlign: "center",
          fontFamily: H.label,
          fontSize: 10,
          letterSpacing: "0.14em",
          textTransform: "uppercase",
          color: H.inkDim,
          margin: "20px 0 0",
        }}
      >
        {t("tippeModulWische")}
      </div>
      <div
        ref={chipRowRef}
        data-chips="1"
        style={{
          position: "relative",
          margin: "12px 0 0",
          padding: `2px ${MOBILE_HERO_GUTTER}px 8px`,
          overflow: "visible",
        }}
      >
        <div
          className="mkhero-chipcar"
          style={{
            display: "grid",
            gridTemplateRows: "auto auto",
            gridAutoFlow: "column",
            gridAutoColumns: "max-content",
            justifyContent: "start",
            gap: 9,
            overflowX: "auto",
            overflowY: "hidden",
          }}
        >
          {heroFeatureChips(tChips).map((chip) => (
            <Pill
              key={chip.label}
              active={props.active === chip.key}
              onClick={() => {
                handleChipClick(chip.key);
              }}
              style={{ whiteSpace: "nowrap" }}
            >
              {chip.label}
            </Pill>
          ))}
        </div>
        <HeroDemoCursor rootRef={chipRowRef} />
      </div>
    </>
  );
}
